import { type FC } from 'react'
import styled from 'styled-components'
import { LANG, LANG_COUNTRY, STORE_ABBR } from '@/utils'
import { createUnderline, mq, presets, vw } from '@/styles'

const CONTACT_DATA_BY_STORE_COUNTRY = {
  mmf: {
    'es-ES': {
      email: 'mailto:info@mammafiore.eu',
      // tel: { href: '+34933037615', text: '+34 93 303 76 15' }
    },
    'en-GB': {
      email: 'mailto:london@mammafiore.eu',
      tel: { href: '+4402037576120', text: '+44 (0) 2037576120' }
    },
    'de-DE': {
      email: 'mailto:berlin@mammafiore.eu',
      tel: { href: '+493027980249', text: '+49 3027980249' }
    },
    'fr-FR': {
      email: 'https://mammafiorehelp.zendesk.com/hc/fr',
      // tel: { href: '+330148904750', text: '+33 (0) 148 904 750' }
    },
    'pt-PT': {
      email: 'mailto:geral@mammafiore.eu',
      tel: { href: '+351932816161', text: '+351 93 281 61 61' }
    },
  },
  hm: {
    'es-ES': {
      email: 'mailto:hola@hellomamma.eu',
      // tel: { href: '0034933037615', text: '+34 93 303 76 15' }
    },
    'en-GB': {
      email: 'mailto:hello@hellomamma.co.uk',
      tel: { href: '4407946173345', text: '07946 173345' }
    },
    'fr-FR': {
      email: 'mailto:salut@hellomamma.eu',
      tel: { href: '0033148904750', text: '+33 (0) 148 904 750' }
    },
  }
}

export type TypeTel = { href: string, text: string }
const CONTACT_US_TRANSLATION_OBJECT = {
  en: (email: string, tel?:TypeTel) =>
    `Do you have questions? <br/><a href='${email}'>Write to us</a>${tel ? ` or call us at <br/><a href='tel:${tel.href}'>${tel?.text}</a>` : '.'}`,
  es: (email: string, tel?:TypeTel) =>
    `¿Tienes preguntas? <br/><a href='${email}'>Escríbenos</a>${tel ? ` o llama al <br/><a href='tel:${tel.href}'>${tel?.text}</a>` : '.'}`,
  fr: (email: string, tel?:TypeTel) =>
    `Vous avez des questions ? <br/><a class='email' href='${email}'>Écrivez-nous</a>${tel ? ` ou appelez-nous au <br/><a href='tel:${tel.href}'>${tel?.text}</a>` : '.'}`,
  de: (email: string, tel?:TypeTel) =>
    `Haben Sie Fragen? <br/><a href='${email}'>Schreiben Sie uns</a>${tel ? ` oder rufen Sie uns an unter <br/><a href='tel:${tel.href}'>${tel?.text}</a>` : '.'}`,
  it: (email: string, tel?:TypeTel) =>
    `Hai domande? <br/><a href='${email}'>Scrivici</a>${tel ? ` o chiamaci al <br/><a href='tel:${tel.href}'>${tel?.text}</a>` : '.'}`,
  pt: (email: string, tel?:TypeTel) =>
    `Tem perguntas? <br/><a href='${email}'>Escreva para nós</a>${tel ? ` ou ligue para <br/><a href='tel:${tel.href}'>${tel?.text}</a>` : '.'}`,
} as const

const email = CONTACT_DATA_BY_STORE_COUNTRY[STORE_ABBR][LANG_COUNTRY].email
const tel = CONTACT_DATA_BY_STORE_COUNTRY[STORE_ABBR][LANG_COUNTRY].tel
const message = CONTACT_US_TRANSLATION_OBJECT[LANG](email, tel)

export const ContactUs:FC = () => {
  return (
    <P dangerouslySetInnerHTML={{ __html: message }} />
  )
}

const P = styled.p`
  ${presets.font20}
  font-family: var(--font-graphik);
  grid-column: 1 / span 6;
  margin-bottom: 50px;

  ${mq.greaterThan('tablet')} {
    grid-column: 9 / span 4;
    grid-row: 1 / span 1;
    order: 3;
  }

  a {
		&.email,
    &[href^='mailto:'] {
      ${createUnderline({ color: 'var(--color-background)', reverse: true })};
    }

    &[href^='tel:'] {
      ${createUnderline({ color: 'var(--color-gold-background)', height: 2 })}
      ${presets.font27_P18}
      display: flex;
      margin-top: ${vw(10, 'mobile')};
      width: fit-content;

      ${mq.greaterThan('tablet')} {
        ${presets.font53_2}
        margin-top: ${vw(30, 'desktop')};
      }
    }
  }
`
